/**
 * @fileoverview Shared subject and description fields for notification content.
 * @module pages/notificationForm/NotificationFormSubjectFields
 */
import styles from "../../styles/NotificationForm.module.css";
import { useTranslation } from "react-i18next";
import { NOTIFICATION_FORM_I18N_KEYS } from "./notificationFormConstants.js";

/** Subject and optional description inputs for notification content blocks. */
const NotificationFormSubjectFields = ({
  asunto,
  descripcion,
  showError,
  showDescription = true,
  onAsuntoChange,
  onDescripcionChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.detailsCol}>
      <div className={styles.subjectContainer}>
        <label className={styles.inputLabel}>
          {t(NOTIFICATION_FORM_I18N_KEYS.SUBJECT)}
          <span className={styles.required}> *</span>
        </label>
        <input
          type="text"
          name="asunto"
          placeholder={t(NOTIFICATION_FORM_I18N_KEYS.SUBJECT_PLACEHOLDER)}
          value={asunto}
          onChange={onAsuntoChange}
          className={styles.input}
        />
      </div>
      {showDescription && (
        <div className={styles.descriptionContainer}>
          <label className={styles.label}>
            {t(NOTIFICATION_FORM_I18N_KEYS.DESCRIPTION)}
            <span className={styles.required}> *</span>
          </label>
          <textarea
            name="descripcion"
            value={descripcion}
            onChange={onDescripcionChange}
            className={styles.textarea}
            style={{
              borderColor:
                showError && !descripcion ? "red" : "#909092",
            }}
            placeholder={t(NOTIFICATION_FORM_I18N_KEYS.DESCRIPTION_PLACEHOLDER)}
          />
        </div>
      )}
    </div>
  );
};

export default NotificationFormSubjectFields;
